function searchClearFunc() {
	function checkSearchVal() {
		const searchVal = jQuery('.search-field__input').val();
		if (searchVal === '') {
			jQuery('.search .search-field__clear').removeClass('active');
		} else {
			jQuery('.search .search-field__clear').addClass('active');
		}
	}
	checkSearchVal();
	jQuery('.search .search-field__input').keyup(function () {
		checkSearchVal();
		searchEmptyResult();
	});
	jQuery('.search .search-field__clear').click(function (e) {
		e.preventDefault();
		jQuery('.search-field__input').val('');
		jQuery('.search .search-hero').addClass('search-empty');
		jQuery('.search .search-field__clear').removeClass('active');
	});

	jQuery('.search .no-result__buttons .clear-search-btn').click(function (e) {
		e.preventDefault();
		const searchFieldTop = jQuery('.search-field__input').offset().top;
		const scrollPosition = jQuery(window).scrollTop();
		const viewportHeight = jQuery(window).height();
		const headerHeight = jQuery('.search .main-header').outerHeight();
		const scrollTarget = searchFieldTop - headerHeight;
		const searchFieldHeight = jQuery('.search-field__input').outerHeight();
		if (
			searchFieldTop >= scrollPosition &&
			searchFieldTop + searchFieldHeight <=
				scrollPosition + viewportHeight
		) {
			clearSearchInputAndFocus();
		} else {
			jQuery('html, body').animate(
				{
					scrollTop: scrollTarget,
				},
				500,
				function () {
					clearSearchInputAndFocus();
				}
			);
		}
	});
}

function clearSearchInputAndFocus() {
	jQuery('.search-field__input').val('');
	jQuery('.search .search-hero').addClass('search-empty');
	jQuery('.search .search-field__clear').removeClass('active');
	jQuery('.search-field__input').focus();
}

function searchEmptyResult() {
	jQuery('.search .search-field__input').removeClass('empty-search');
}

function searchClear() {
	searchClearFunc();
}
export default searchClear;
